function getConfig(name, defaultValue = null) {
  // If inside a docker container, use window.ENV
  if (window.ENV !== undefined) {
    return window.ENV[name] || defaultValue;
  }

  return import.meta.env[name] || defaultValue;
}

export function getBackendUrl() {
  const envUrl = getConfig("VITE_BACKEND_URL");

  if (envUrl) {
    return envUrl;
  }

  const port = 8080;
  return `${window.location.protocol}//${window.location.hostname}:${port}`;
}

export function getHoursCloseTicketsAuto() {
  return getConfig("VITE_HOURS_CLOSE_TICKETS_AUTO");
}
